import { render } from "./_poll-list.vue?vue&type=template&id=1ab6f3ce&lang=pug"
import script from "./_poll-list.vue?vue&type=script&lang=js"
export * from "./_poll-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__